/**
 * メインエントリーポイント
 * 旧 assets/js/akbtheme/top.js の機能を移行
 */

import { animation, animationImmediate, typewriter } from './modules/animation.js';
import { accordion } from './modules/accordion.js';
import { hamburger } from './modules/hamburger.js';
import { smoothScroll } from './modules/smoothScroll.js';
import { initSwipers } from './modules/swiper-init.js';

let mainHeight = 0;

/**
 * トップページヒーロー高さセット
 */
function setFillHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

/**
 * 画像切り替え機能
 */
function switchImage() {
  const windowW = window.innerWidth;
  const pcImages = document.querySelectorAll('[data-pc-src]');
  const spImages = document.querySelectorAll('[data-sp-src]');

  if (windowW >= 768) {
    pcImages.forEach((img) => {
      const pcSrc = img.dataset.pcSrc;
      if (pcSrc) img.src = pcSrc;
    });
  } else {
    spImages.forEach((img) => {
      const spSrc = img.dataset.spSrc;
      if (spSrc) img.src = spSrc;
    });
  }
}

/**
 * メインアニメーション実行
 */
function mainAnime() {
  // js-main は即時アニメーション（カーテン）
  setTimeout(() => animationImmediate('js-main'), 500);
  setTimeout(() => typewriter('js-typewriter'), 1500);
  // js-anime はスクロールトリガー
  setTimeout(() => animation('js-anime'), 500);

  // Swiper初期化
  initSwipers();
}

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
  const body = document.getElementsByTagName('body')[0];

  // メインアニメーション
  mainAnime();

  // ブラウザの戻るボタン時はアニメーション即時実行
  const perfEntries = performance.getEntriesByType('navigation');
  perfEntries.forEach(function (pe) {
    if (pe.type === 'back_forward') {
      body.classList.add('back-forward');
    }
  });
});

// Window load
window.addEventListener('load', function () {
  // アコーディオン
  accordion('js-accordion');

  // ハンバーガー
  hamburger('js-hamburger');

  // スムーススクロール
  smoothScroll();

  // 画像切り替え
  switchImage();

  // リサイズイベント発火
  window.dispatchEvent(new Event('resize'));
});

// Scroll
window.addEventListener('scroll', function () {
  const scrollY = window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop;
  const body = document.getElementsByTagName('body')[0];

  if (scrollY > mainHeight / 2) {
    body.classList.add('scrolled');
  } else {
    body.classList.remove('scrolled');
  }
});

// Resize
let windowW = window.innerWidth;
window.addEventListener('resize', function () {
  if (windowW === window.innerWidth) {
    return;
  }
  windowW = window.innerWidth;
  mainAnime();

  // Google翻訳要素の移動
  const width = window.innerWidth;
  const to =
    width >= 768
      ? document.getElementsByClassName('akb-langPC')[0]
      : document.getElementsByClassName('akb-langSP')[0];
});
